<template>
  <div class="mobile">
    <div class="design-header">
      <span class="title">モバイル</span>
    </div>
    <div class="text-box">
      <unit-text
        v-for="mobileStyle in mobileStyles"
        :key="mobileStyle.selector"
        :target="'mobile'"
        :selector="mobileStyle.selector"
        :styles="mobileStyle.styles"
        :label="mobileStyle.label"
        @updateStyles="updateMobileStyles($event)"
      />
    </div>
    <div class="design-footer">
      <button
        class="close normal-btn"
        @click="closeButton"
        data-shortcut-esc="editorCloseButton"
      >
        閉じる
      </button>
    </div>
  </div>
</template>

<script>
import Base from '@/components/Content/Palette/ContentDesign/ContentDesignBase'
import ShortCutBase from '@/mixins/ShortCutBase'
import UnitText from '@/components/Content/Palette/ContentDesign/UnitText'

export default {
  mixins: [
    Base,
    ShortCutBase
  ],
  components: {
    UnitText,
  },
  data () {
    return {
      mobileStyles: []
    }
  },
  computed: {
    sections: {
      cache: false,
      get () {
        return this.$store.getters.getSectionAll
      }
    },
    storeMobileStyles: {
      cache: false,
      get () {
        return this.$store.getters.findMobileStyles
      }
    }
  },
  methods: {
    initMobileStyles () {
      // セレクタの一覧を作成：h1〜h4の見出し、テキストボックス
      let selectors = [
        { key: 'h1', label: 'h1 (見出し1)' },
        { key: 'h2', label: 'h2 (見出し2)' },
        { key: 'h3', label: 'h3 (見出し3)' },
        { key: 'h4', label: 'h4 (見出し4)' },
        { key: '.part-boxed-text', label: 'テキストボックス' }
      ]
      // セレクタの一覧を作成：各セクション
      const sections = this.$store.getters.getSectionAll
      sections.forEach(section => {
        selectors.push({
          key: `.section-${section.name}`,
          label: section.name
        })
      })
      // セレクタごとのスタイルを、mobileStylesに追加
      selectors.forEach(selector => {
        this.mobileStyles.push({
          selector: selector.key,
          styles: this.$store.getters.findMobileStyleAll(selector.key) || null,
          label: selector.label
        })
      })
    },
    updateMobileStyles (event) {
      this.$store.commit('updateMobileStyles', {
        selector: event.selector,
        styles: event.styles
      })
    }
  },
  watch: {
    // storeの値が更新されたら、mobileStylesも更新する
    storeMobileStyles: {
      deep: true,
      handler: function (values) {
        values.forEach(value => {
          const selectorIndex = this.mobileStyles.findIndex(mobileStyle => mobileStyle.selector === value.selector)
          const selector = this.mobileStyles.find(mobileStyle => mobileStyle.selector === value.selector)
          const updateObject = {
            label: selector.label,
            selector: value.selector,
            styles: this.$store.getters.findMobileStyleAll(value.selector) || null
          }
          this.$set(this.mobileStyles, selectorIndex, updateObject)
        })
      }
    }
  },
  beforeMount () {
    this.initMobileStyles()
  }
}
</script>

<style lang="scss" scoped>
.design-header, .design-footer {
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #dbdbdb;
  background: #ffffff;
  position: relative;
}
.design-header {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-top: 1px solid #dbdbdb;
  background: #f8f8f8;
  .btn {
    position: absolute;
    top: 10px;
    left: 20px;
    opacity: 0.5;
    font-size: 16px;
    margin: 0 !important;
    padding: 0 !important;
    background: none;
    border: none;
    color: $commonFontColor;
    transition: all 0.3s ease 0s;
    &::before {
      font-family: "Font Awesome 5 Free";
      content: '\f104';
      font-weight: 900;
      padding-right: 2px;
    }
    &:hover {
      opacity: 1;
    }
  }
  .title {
    color: $commonFontColor;
  }
}
.design-footer {
  vertical-align: bottom;
  border-top: #dbdbdb 1px solid;
  text-align: right;
  .close {
    width: auto;
    display: block;
    font-size: 14px;
    border-radius: 5px;
    color: #fff;
    border: solid 1px #484848;
    background: #484848;
    opacity: 1;
    position: absolute;
    top: 6px;
    right: 8px;
    &:hover {
      background: #484848;
      opacity: 0.8;
    }
  }
}
.text-box {
  height: calc(100vh -  240px);
  overflow: auto;
}
</style>
